<template>
  <Modal
    class="detail-modal"
    data-testid="detail-modal-v2"
    :is-open="isOpen"
    size="md"
    title=""
    @close="emit('close')"
  >
    <div>
      <div class="modal-detail__header">
        <Heading class="modal-detail__text" :level="3">
          {{ details.title }}
        </Heading>
        <BaseText
          class="modal-detail__text"
          :color="NebraskaColors.textSecondary"
          size="md"
        >
          {{ details.description }}
        </BaseText>
      </div>
    </div>
    <template #buttonContainer>
      <ButtonContainer>
        <template #button-primary>
          <div
            v-for="(button, index) in details.buttons"
            :key="`primary-button-${index}`"
          >
            <ButtonPrimary
              v-if="button.style === EPortfolioAboutButtonStyle.PRIMARY"
              :label="button.label"
              :action="button.action"
              @click="handleButtonAction(button.action)"
            />
          </div>
        </template>
        <template #button-secondary>
          <div
            v-for="(button, index) in details.buttons"
            :key="`secondary-button-${index}`"
          >
            <ButtonSecondary
              v-if="button.style === EPortfolioAboutButtonStyle.SECONDARY"
              :label="button.label"
              @click="handleButtonAction(button.action)"
            />
          </div>
        </template>
      </ButtonContainer>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import {
  BaseText,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary,
  Heading,
  Modal
} from '@warrenbrasil/nebraska-web';
import {
  EPortfolioAboutAction,
  EPortfolioAboutButtonStyle,
  IPortfolioAboutDetails
} from '../../services/portfolio';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { useRouter } from 'vue-router/composables';

const router = useRouter();

defineProps<{
  details: IPortfolioAboutDetails;
  isOpen: boolean;
}>();

const emit = defineEmits(['close']);

function handleButtonAction(action: EPortfolioAboutAction) {
  switch (action) {
    case EPortfolioAboutAction.CLOSE:
      emit('close');
      break;
    case EPortfolioAboutAction.GO_TO_COSTS:
      router.push({ name: 'costs' });
      break;
  }
}
</script>

<style lang="less" scoped>
:deep(.modal-content) {
  padding: 0;
}
.content_modal-enter,
.content_modal-leave-to {
  transform: translate(100%, 0);
}

.modal-detail {
  &__text {
    margin-bottom: @size-spacing-x400;
    text-align: start;
  }
  &__header {
    margin-bottom: @size-spacing-x400;
    padding: 0 @size-spacing-x500 @size-spacing-x500 @size-spacing-x500;
  }

  @media (min-width: 1024px) {
    &__header {
      padding: 0 @size-spacing-x1000 @size-spacing-x600 @size-spacing-x1000;
    }
    &__wrapper {
      padding: 0 @size-spacing-x1000 @size-spacing-x600 @size-spacing-x1000;
    }
  }
}
</style>
